<div class="row">
  <div class="col-md-6" *ngFor="let size of sizes">
    <ui-cake-build-size
      [size]="size"
      [active]="isActiveSize(size)"
      [currency]="currency"
      [discount]="discount"
      (onSelect)="activeSize = $event; onSelect.emit($event)"
    ></ui-cake-build-size>
  </div>
</div>
